import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { ReasonService, DropReason } from './reason.service';
import { LoadingMaskService } from '../../../../../shared/loading-mask/loading-mask.service';

@Injectable()
export class ReasonResolve implements Resolve<DropReason[]> {
	constructor(private service: ReasonService,
	            private loadingMask: LoadingMaskService) {
	}

	resolve(route: ActivatedRouteSnapshot): Promise<DropReason[]> {
		this.loadingMask.addLoading();
		return this.service.getReasons().then((reasons) => {
			this.loadingMask.removeLoading();
			return reasons
		});
	}
}
